// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"58e72e32","239":"83bdaef5","455":"3862a799"}[chunkId] + ".chunk.js";
};